export default __webpack_public_path__ + "static/media/LogoMakr-3opelv.b00c1981.svg";